// extracted by mini-css-extract-plugin
export default {"title":"styles_title__C5h2V","description":"styles_description__P5JAJ","count":"styles_count__YDfsi"};